<template>
  <div class="page">
    <div class="container">
      <h1>About LMP</h1>
      <Panel header="About the System" class="mb-4">
        <p class="mb-4">This Vue.js Single Page Application demonstrates:</p>
        <ul class="mb-4">
          <li>Responsive design that maximizes screen usage</li>
          <li>Mobile-first approach with hamburger menu</li>
          <li>Vue Router for seamless navigation</li>
          <li>PrimeVue 4 components with modern styling</li>
          <li>Clean, minimal code structure</li>
        </ul>
        
        <Divider />
        
        <h3 class="mb-3">Tech Stack</h3>
        <div class="flex flex-wrap gap-2">
          <Tag value="Vue 3" severity="success" />
          <Tag value="Vue Router" severity="info" />
          <Tag value="PrimeVue 4" severity="warn" />
          <Tag value="Vite" severity="danger" />
        </div>
      </Panel>
      
      <Panel header="Features" class="mb-4">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Card>
            <template #title>
              <i class="pi pi-mobile mr-2"></i>Responsive Design
            </template>
            <template #content>
              <p>Adapts seamlessly to all screen sizes and devices</p>
            </template>
          </Card>
          <Card>
            <template #title>
              <i class="pi pi-palette mr-2"></i>Modern UI
            </template>
            <template #content>
              <p>Clean interface with PrimeVue components</p>
            </template>
          </Card>
          <Card>
            <template #title>
              <i class="pi pi-shield mr-2"></i>Secure
            </template>
            <template #content>
              <p>Built with security best practices</p>
            </template>
          </Card>
          <Card>
            <template #title>
              <i class="pi pi-bolt mr-2"></i>Fast Performance
            </template>
            <template #content>
              <p>Optimized for speed and efficiency</p>
            </template>
          </Card>
        </div>
      </Panel>
    </div>
  </div>
</template>

<script>
import Panel from 'primevue/panel'
import Card from 'primevue/card'
import Tag from 'primevue/tag'
import Divider from 'primevue/divider'

export default {
  components: {
    Panel,
    Card,
    Tag,
    Divider
  }
}
</script>

<style scoped>
.page {
  padding: 2rem;
  background: var(--p-surface-50);
  min-height: 100vh;
}

.container {
  max-width: 1000px;
  margin: 0 auto;
}

h1 {
  font-size: 2.5rem;
  margin-bottom: 2rem;
  text-align: center;
  color: var(--p-text-color);
}

.mb-3 {
  margin-bottom: 1rem;
}

.mb-4 {
  margin-bottom: 1.5rem;
}

.mr-2 {
  margin-right: 0.5rem;
}

.flex {
  display: flex;
}

.flex-wrap {
  flex-wrap: wrap;
}

.gap-2 {
  gap: 0.5rem;
}

.gap-4 {
  gap: 1rem;
}

.grid {
  display: grid;
}

.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

@media (min-width: 768px) {
  .md\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .page {
    padding: 1rem;
  }
  
  h1 {
    font-size: 2rem;
  }
}
</style>